exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-size-12px{font-size:12px}.login-promotion-modal{position:fixed;top:0;left:0;z-index:1000000000;overflow-y:scroll;height:100%;width:100%;padding:10px}.login-promotion-modal>div{max-width:600px;margin-left:auto;margin-right:auto;background:#ccc;margin-bottom:30px;padding-bottom:10px}\n", ""]);

// exports
